import { useEffect, useRef } from 'react'
import { useRouterState } from '@tanstack/react-router'

export const MAIN_CONTENT_ID = 'main-content'

export function focusMain(): void {
  document.getElementById(MAIN_CONTENT_ID)?.focus()
}

export function useRouteFocus(): void {
  const routeKey = useRouterState({
    select: (s) => {
      const match = s.matches.at(-1)
      return match ? `${match.routeId}:${JSON.stringify(match.params)}` : ''
    },
  })
  const previous = useRef<string | null>(null)

  useEffect(() => {
    if (previous.current !== null && previous.current !== routeKey) {
      focusMain()
    }
    previous.current = routeKey
  }, [routeKey])
}
